/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../axios-client";
import type { GetApiPublicBranchServicesQueryResponse, GetApiPublicBranchServicesQueryParams } from "../entities/GetApiPublicBranchServices";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { getApiPublicBranchServices } from "../api/getApiPublicBranchServices";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getApiPublicBranchServicesQueryKey = (params: GetApiPublicBranchServicesQueryParams) => [{ url: '/api/public/branch/services' }, ...(params ? [params] : [])] as const

export type GetApiPublicBranchServicesQueryKey = ReturnType<typeof getApiPublicBranchServicesQueryKey>

export function getApiPublicBranchServicesQueryOptions(params: GetApiPublicBranchServicesQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = getApiPublicBranchServicesQueryKey(params)
        return queryOptions<GetApiPublicBranchServicesQueryResponse, ResponseErrorConfig<Error>, GetApiPublicBranchServicesQueryResponse, typeof queryKey>({
         
         queryKey,
         queryFn: async ({ signal }) => {
            return getApiPublicBranchServices(params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Получить доступные услуги (стрижки) выбранного филиала
 * @summary Получить услуги филиала
 * {@link /api/public/branch/services}
 */
export function useGetApiPublicBranchServices<TData = GetApiPublicBranchServicesQueryResponse, TQueryData = GetApiPublicBranchServicesQueryResponse, TQueryKey extends QueryKey = GetApiPublicBranchServicesQueryKey>(params: GetApiPublicBranchServicesQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<GetApiPublicBranchServicesQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? getApiPublicBranchServicesQueryKey(params)
         

         const query = useQuery({
          ...getApiPublicBranchServicesQueryOptions(params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}